export function postData(url, data) {
	// Default options are marked with *
	return fetch(url, {
		body: data, // must match 'Content-Type' header
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		redirect: 'follow', // manual, *follow, error
	})
	.then(response => response.json()) // parses response to JSON
}



// WEBPACK FOOTER //
// ./src/helpers.js